// extracted by mini-css-extract-plugin
module.exports = {"title":"AuthLink_title__26bIL","clickable":"AuthLink_clickable__1RkZo"};